import { graphql } from '~/graphql';
import { useGraphqlMutation } from '~/hooks/useGraphqlMutation';
import { useGraphqlQuery } from '~/hooks/useGraphqlQuery';
import type { MySellerListsQuery } from '~/graphql/graphql';

const MY_SELLER_LISTS_QUERY_KEY = 'mySellerLists';

const mySellerListsQuery = graphql(`
  query MySellerLists {
    mySellerLists {
      id
      name
      members {
        seller {
          id
          name
          sellingOrganizationCode
        }
        contacts {
          id
          firstName
          lastName
        }
      }
    }
  }
`);

const saveSellerListMutation = graphql(`
  mutation SaveSellerList(
    $id: ID
    $name: String!
    $members: [SellerListMemberInput!]!
  ) {
    saveSellerList(id: $id, name: $name, members: $members) {
      id
    }
  }
`);

const deleteSellerListMutation = graphql(`
  mutation DeleteSellerList($id: ID!) {
    deleteSellerList(id: $id)
  }
`);

export type SellerList = MySellerListsQuery['mySellerLists'][number];

export const useMySellerLists = () =>
  useGraphqlQuery(mySellerListsQuery, [MY_SELLER_LISTS_QUERY_KEY]);

export const useSaveSellerList = () =>
  useGraphqlMutation(saveSellerListMutation, [MY_SELLER_LISTS_QUERY_KEY]);

export const useDeleteSellerList = () =>
  useGraphqlMutation(deleteSellerListMutation, [MY_SELLER_LISTS_QUERY_KEY]);
